<template>
	<form class="c-form-ai-clone" @submit.prevent="onSubmit">
		<Form
			ref="form"
			:errors="errors"
			:schema="schema"
			v-model="form"
			@status="saveStatus"
			buttonText="Update Settings"
			:processing="processing"
		></Form>
	</form>
</template>

<script>
import Form from './index.vue';

const schema = {
	brandName: {
		component: 'InputText',
		label: 'Your brand name',
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
			minLength: {
				params: 1,
				message: "Your brand name can't be that short, surely?",
			},
			maxLength: {
				params: 50,
				message: `Whoa, that's a long name`,
			},
		},
	},
	prompt: {
		component: 'InputTextarea',
		label: 'Custom prompt',
		description:
			'Use this to enter custom instructions, eg: Use #ff4023 as brand color, set title to "xyz", etc.',
		validations: {
			maxLength: {
				params: 300,
				message: `Max 300 characters instructions`,
			},
		},
	},
	images: {
		component: 'InputUploadMultiple',
		label: 'Product images',
		description: 'Upload at least 1 image',
		validations: {},
	},
};

export default {
	components: {
		Form,
	},

	data: function () {
		return {
			errors: [],
			schema: schema,
			processing: false,
			form: {
				id: null,
				name: '',
				lastName: '',
			},
			status: null,
		};
	},

	props: {
		adId: {},
	},

	methods: {
		saveStatus: function (saveStatus) {
			this.status = saveStatus;
		},
		getUser: function () {
			return this.$store.getters['users/user'];
		},
		async onSubmit() {
			this.errors = [];

			this.$refs.form.validate();

			if (this.status.invalid) {
				return;
			}

			this.processing = true;

			let form = this.form;

			form = {
				adId: this.adId,
				brandName: form.brandName,
				prompt: form.prompt,
				images: form.images,
			};

			let formData = new FormData();

			formData.append('adId', form.adId);
			formData.append('brandName', form.brandName);
			formData.append('prompt', form.prompt);
			if (form.images && form.images.length) {
				form.images.forEach((file) => {
					formData.append('images[]', file);
				});
			}

			try {
				let res = null;
				res = await this.$store.dispatch('app/aiClone', formData);
			} catch (err) {
				if (typeof err === 'object' && err.length) {
					this.errors = err;
				}
				this.processing = false;
				return;
			}
			this.processing = false;
			await this.$store.dispatch('message/onUserUpdate');
			this.$emit('onSubmit');
		},
	},

	created: function () {},
};
</script>

<style lang="scss">
.c-form-ai-clone {
	padding: 0.5rem;
}
</style>
